var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolanaChain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.46885 7.37799C3.51475 7.33411 3.57697 7.30946 3.64184 7.30946H9.6274C9.73643 7.30946 9.79101 7.43565 9.71388 7.50941L8.53115 8.64044C8.48526 8.68433 8.42304 8.70899 8.35817 8.70898H2.37261C2.26358 8.70898 2.20899 8.58279 2.28611 8.50903L3.46885 7.37799Z",
    fill: "url(#paint0_linear_3008_52678)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.46885 3.15253C3.51474 3.10864 3.57696 3.08398 3.64184 3.08398H9.6274C9.73643 3.08398 9.79101 3.21017 9.71388 3.28394L8.53115 4.41498C8.48526 4.45886 8.42304 4.4835 8.35817 4.4835H2.37261C2.26358 4.4835 2.20899 4.35731 2.28611 4.28356L3.46885 3.15253Z",
    fill: "url(#paint1_linear_3008_52678)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53115 5.2518C8.48526 5.20792 8.42304 5.18327 8.35817 5.18327H2.37261C2.26358 5.18327 2.20899 5.30946 2.28611 5.38322L3.46885 6.51425C3.51474 6.55814 3.57696 6.58279 3.64184 6.58279H9.6274C9.73643 6.58279 9.79101 6.4566 9.71388 6.38283L8.53115 5.2518Z",
    fill: "url(#paint2_linear_3008_52678)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3008_52678",
    x1: 7.32044,
    y1: 1.54103,
    x2: 3.45656,
    y2: 9.27404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3008_52678",
    x1: 7.32044,
    y1: 1.54103,
    x2: 3.45656,
    y2: 9.27404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3008_52678",
    x1: 7.32044,
    y1: 1.54103,
    x2: 3.45656,
    y2: 9.27404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolanaChain);
export default __webpack_public_path__ + "static/media/solana-chain.ceb535aa265a8eb38959f9878054acbb.svg";
export { ForwardRef as ReactComponent };